import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    appTitle: 'NCPS',
    memberName: 'undefined name',
    roles: '',
    loggedIn: false,
    memberInfo: {},
    banners: {},
    photoshoots: [],
    meetings: [],
    galleries: [],
    userHasGallery: false,
    meetingInfo: {id: 0},
    prettyBoxes: [],
  },
  mutations: {
    setRoles (state, roles) {
      state.roles = roles
    },
    setMemberName (state, memberName) {
      state.memberName = memberName
    },
    setMemberInfo (state, memberInfo) {
      state.memberInfo = memberInfo
    },
    setLoggedIn (state, isLoggedIn) {
      state.loggedIn = isLoggedIn
    },
    setLoginToken (state, loginToken) {
      state.loginToken = loginToken
    },
    setBanners (state, banners) {
      state.banners = banners
    },
    setPhotoshoots (state, photoshoots) {
      state.photoshoots = photoshoots
    },
    setMeetings (state, meetings) {
      state.meetings = meetings
    },
    setGalleries (state, galleries) {
      state.galleries = galleries
    },
    setUserHasGallery (state, hasGallery) {
      state.userHasGallery = hasGallery
    },
    setMeetingInfo (state, meetingInfo) {
      state.meetingInfo = meetingInfo
    }
  },
  actions: {},
  getters: {}
})
